const __request = require(`@/lib/data-service/default/__request/__request_contentType_json.js`)

/**
 * 预定切位订单
 */
export default function getDetail(val) {
    var pParameter = {}
    pParameter.method = "POST"
    pParameter.urlSuffix = "/web/common/TourismMall/getEdiTourism"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
} 
